// Angular
import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

// Data/Classes/Others
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserDeleteComponent } from '../user-delete/user-delete.component';
import { accountTypeEdit,accountTypesEditAdmin } from '../../../accounts';
import { UserIFace, UserUpdate } from 'src/app/shared/classes';
import { planType, subscriptionType } from '../../../data-tables'


// Services
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { EventsService } from 'src/app/services/events/events.service';
import { NgxSpinnerService } from 'ngx-spinner';


declare var moment: any;

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.less']
})
export class UserEditComponent implements OnInit {
  @Input() user: UserIFace;
  public userEditForm;
  public listOfAllAccounts;
  public accountTemp :any;

  constructor(private fb: FormBuilder, private admin: AdminService, private msg: MessagesService, private ngbModal: NgbModal,
    private ngbActModal: NgbActiveModal, private event: EventsService, private load: NgxSpinnerService) {
  }

  ngOnInit() {
    this.initForm();
  }

  // inits edit user form
  private initForm() {
    let expired_date = "N/A";
    let planType = "N/A";
    if(this.user.from == 'users'){
       this.listOfAllAccounts = accountTypeEdit;
    }
    if (this.user.from == 'admins'){
      this.listOfAllAccounts = accountTypesEditAdmin;
    }
    if(this.user.data.subscription != null){
       let temp = JSON.parse(this.user.data.subscription);
       expired_date = moment(temp.account.expired_date).format('YYYY-MM-DDThh:mm');
       planType = temp.account.plan_type;
    }
    this.userEditForm = this.fb.group({
      userid: [this.user.data.user_id, []],
      adminid: [this.user.data.admin_id, []],
      firstName: [this.user.data.first_name, [Validators.required, Validators.minLength(2)]],
      lastName: [this.user.data.last_name, [Validators.required, Validators.minLength(1)]],
      email: [this.user.data.email, [Validators.required, Validators.email]],
      accountType: [String(this.user.data.account_type).toLowerCase()
        , [Validators.required]],
      expired_date : [expired_date],
      planType: [planType]
    });

    this.accountTemp = this.user.data.account_type;
  }

  // updates user
  public updateUser() {
    this.load.show();
    // get updated user deets
    const from = this.user.from;

    const fName = this.userEditForm.value.firstName;
    const lName = this.userEditForm.value.lastName;
    const email = this.userEditForm.value.email;
    const accType = this.userEditForm.value.accountType;
    let planType =  this.userEditForm.value.planType || null;
    let expired = this.userEditForm.value.expired_date || null;
    
    let subscription = null;
    /** update from 1 plan to another plan*/
      if((accType == 'beginner' || accType == 'developer') && this.user.data.subscription != null){
        subscription = JSON.parse(this.user.data.subscription);
        if(planType != null){

           let temp = planType.split("_");
           let tempExpired = moment(subscription.account.expired_date);
           if(temp[1] === 'yearly'){
             tempExpired.add(Number(temp[2]),'years');
           }
           if(temp[1] === 'monthly'){
             tempExpired.add(Number(temp[2]),'months');
           }
           subscription.account.expired_date = tempExpired.format();
           subscription.account.plan_type = planType;
        }
     }
     /**update from free to beginner or developer */
     if((accType == 'beginner' || accType == 'developer') && this.user.data.subscription == null){
        let temp = planType.split("_");
        let tempExpired = moment();

        if(temp[1] === 'yearly'){
          tempExpired.add(Number(temp[2]),'years');
        }
        if(temp[1] === 'monthly'){
          tempExpired.add(Number(temp[2]),'months');
        }
        subscription = {
          account:{
            package  : accType,
            activate : true,
            start_date: moment().format(),
            expired_date : tempExpired.format(),
            plan_type : planType
          }
        }
      }
       /**Restrict or suspend account */
       else if(accType == 'Suspend' || accType == 'expired'){
          subscription = JSON.parse(this.user.data.subscription);
       }

       else if(accType == 'free'){
          subscription = null;
       }
       /**admin user------------------------------------------------------------ */
       else if(this.user.from === 'admins'){
          if(this.user.data.subscription != null){
             subscription = JSON.parse(this.user.data.subscription);
             subscription.account.expired_date = moment(expired).format();
          }
          else{
            subscription = {
              account:{
                package  : 'beginner',
                activate : true,
                start_date : moment(this.user.data.date).format(),
                expired_date : moment(expired).format(),
              }
            }
          }
       }
    const user = new UserUpdate(fName, lName, email, accType,subscription);
   // if user update user
    if (this.user.from === 'users') {
      const userid = this.userEditForm.value.userid;
      this.admin.updateTheUser(user, userid)
        .then(res => this.success(res, user, userid, from))
        .catch(err => this.error(err));
    }


    //if admin update admin
    if (this.user.from === 'admins') {
      const adminid = this.userEditForm.value.adminid;
      this.admin.updateTheAdmin(user, adminid)
        .then(res => this.successadminupdate(res, user, adminid, from))
        .catch(err => this.error(err));
    }
  
}

  // triggers delete user modal
  public triggerDeleteUserModal() {
    // open delete modal
    const modal = this.ngbModal.open(UserDeleteComponent);
    modal.componentInstance.userDetails = this.user;

    modal.result
      .then((msg) => {
        if (msg.success) {
          const userid = msg.user;

          this.ngbActModal.close({ user: userid, task: 'close modal', success: true });
        }
      })
      .catch((msg) => {
        console.log(msg);
      });
  }

  // handle success
  private success(res, user, userid, from) {
    this.load.hide();
    this.event.getTableTriggers();
    this.msg.success(res);
    this.ngbActModal.close();
  }

  private successadminupdate(res, user, userid, from){
    this.load.hide();
    this.event.getTableTriggers();
    this.msg.success(res);
    this.ngbActModal.close();
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }

  public checkAccount(acc){
      this.accountTemp = acc;
  }

  public getItem(plan){
      if(plan == 'planType'){
        let temp = planType[this.accountTemp]
        return temp;
      } 
  }
}
